export default {
	data: function () {
		return {
			currentDate: '',
			currentTime: '',
            userName: ''
		};
	},

	mounted:
	function () {
		setInterval(this.updateTimeDate, 1000);
	},
	methods: {
		updateTimeDate: function () {
			var t = new moment();
			this.currentTime = t.format('HH:mm');
			this.currentDate = t.format('DD.MM.YYYY');
		},
	}
}




// WEBPACK FOOTER //
// ./src/components/external/header/header.js